module.exports = __webpack_public_path__ + "img/nose.6802cd33.jpeg";